
function sendError(type,args){

    $.ajax({
        type: "POST",
        url: "/error",
        contentType: "application/json",
        data: angular.toJson({
            url: $window.location.href,
            message: message,
            type: type,
            stackTrace: stackTrace,
            //cause: ( args[1] || ""),
            user : _.omit(User.get(),["effectivePortlets","portlets"])
        })
    });
}

function prepareLogFn(type,logFn,$delegate) {

    var enhancedLogFn = function enhancedLogFn(...args) {
        //let args = Array.prototype.slice.call(arguments);
        //let now = DateTime.formattedNow();

        // prepend a timestamp to the original output message
        //args[0] = supplant("{0} - {1}", [now, args[0]]);
        logFn.apply($delegate, args);

        sendError(type,args);
    };

    // Special... only needed to support angular-mocks expectations
    enhancedLogFn.logs = [];

    return enhancedLogFn;
};

function enchanceLoggerFn($log) {
    // Save the original $log.debug()

    $log.log = prepareLogFn("log",$log.log,$log);
    $log.info = prepareLogFn("info",$log.info,$log);
    $log.warn = prepareLogFn("warn",$log.warn,$log);
    $log.debug = prepareLogFn("debug",$log.debug,$log);
    $log.exception = prepareLogFn("exception",$log.error,$log);
    $log.error = prepareLogFn("error",$log.error,$log);

    return $log;
};

export default ["$provide",  function($provide) {
    // Register our $log decorator with AngularJS $provider
    $provide.decorator('$log', ["$delegate","LogService",function($delegate,LogService) {
      LogService.enabled = true;
      var methods = {
        error: function() {
          if (LogService.enabled) {
            $delegate.error.apply($delegate, arguments);
            LogService.error.apply(null, arguments);
          }
        },
        log: function() {
          if (LogService.enabled) {
            $delegate.log.apply($delegate, arguments);
            LogService.log.apply(null, arguments);
          }
        },
        info: function() {
          if (LogService.enabled) {
            $delegate.info.apply($delegate, arguments);
            LogService.info.apply(null, arguments);
          }
        },
        warn: function() {
          if (LogService.enabled) {
            $delegate.warn.apply($delegate, arguments);
            LogService.warn.apply(null, arguments);
          }
        }
      };
      return methods;
    }]);
}];



// WEBPACK FOOTER //
// ./src/ui/modules/logging/LogDecorator.js